import { useLocale } from "@hooks/use-locale"

const FormattedDate = (props) => {
  const { locale } = useLocale()
  const { value, ...formatProps } = props

  const date = typeof value === "string" ? new Date(value || 0) : value

  const formattedValue = new Intl.DateTimeFormat(locale, formatProps).format(date)

  return <>{formattedValue}</>
}

function FormattedDateWithDefaults({ value }) {
  return <FormattedDate value={value} timeZone="UTC" year="numeric" month="long" day="numeric" />
}

function FormattedDateForPostCards({ value }) {
  return <FormattedDate value={value} timeZone="UTC" month="long" day="numeric" />
}

export { FormattedDateWithDefaults as default, FormattedDateForPostCards }
